import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=a144ca86"
var script = {}
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=a144ca86&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseLink.vue').default})
